import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import moment from 'moment'
import WechatAuth from 'vue-wechat-auth'
import axios from 'axios'
import { request } from './util/http.js'
import { api } from './util/api.js'
import { toast } from './util/toast.js'
import BaiduMap from 'vue-baidu-map'
// import Vconsole from 'vconsole'

// const vConsole = new Vconsole()

// Vue.use(vConsole)


Vue.use(Vant)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'efnYsgwN05TGWO5vdO2i6AY7E3nFaMds'
})
moment.locale('zh-cn', {
  weekdays: '周日_周一_周二_周三_周四_周五_周六'.split('_')
})
Vue.prototype.$moment = moment
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.prototype.$Route = [
  {name: 'A', detail: '公司 —— 市区', counts: 0},
  {name: 'B', detail: '公司 —— 唐家、金鼎', counts: 0},
  {name: 'C', detail: '公司 —— 海湾城、山海郡', counts: 0},
  {name: 'D', detail: '公司 —— 坦洲、三乡', counts: 0},
  {name: 'E', detail: '公司 —— 西区', counts: 0},
  {name: 'F', detail: '公司 —— 其他', counts: 0}
]

Vue.prototype.$JSRoute = [
  {name: 'G', detail: '30公里以上', counts: 0},
  {name: 'H', detail: '30公里（含）以下', counts: 0}
]


Vue.prototype.$request = request
Vue.prototype.$toast = toast
Vue.prototype.$api = api
// Vue.prototype.$agentid = '8' // 内部测试应用
Vue.prototype.$agentid = '1000040' // 内部拼车


router.beforeEach((to, from, next) => {
  if(to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 清空缓存，重新获取
if (localStorage.getItem('Date') !== moment().format('YYYY-MM-DD')) {
  localStorage.clear()
}
// 企业微信 code 只能使用一次，避免 vue-wechat-auth 重复触发导致二次换票失败
let h5AuthInflight = null
let h5AuthLastCode = ''

function persistH5Auth(code, value, accessToken) {
  const userinfo = value.data
  localStorage.setItem('code', code)
  localStorage.setItem('access_token', accessToken)
  localStorage.setItem('userinfo', JSON.stringify(value))
  localStorage.setItem('UserId', userinfo.userid)
  localStorage.setItem('Area', userinfo.area)
  localStorage.setItem('DepartmentName', userinfo.departmentName)
  localStorage.setItem('Date', moment().format('YYYY-MM-DD'))
}

function requestH5Auth(code) {
  if (h5AuthInflight && h5AuthLastCode === code) {
    return h5AuthInflight
  }
  h5AuthLastCode = code
  h5AuthInflight = axios.get('https://pinche.jafron.com/api/WXAuthorize/getH5Auth', {
    params: { code }
  }).finally(() => {
    if (h5AuthLastCode === code) {
      h5AuthInflight = null
    }
  })
  return h5AuthInflight
}

// 微信授权插件初始化
Vue.use(WechatAuth, {
  router, // 路由实例对象
  appid: 'wxdf5df2adda0272b2', // 您的微信appid
  responseType: 'code',  // 返回类型，请填写code
  scope: 'snsapi_base', // 应用授权作用域，snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且，即使在未关注的情况下，只要用户授权，也能获取其信息）
  getCodeCallback(code, next) {
    // 用户同意授权后回调方法
    // code：用户同意授权后，获得code值
    // code说明： code作为换取access_token的票据，每次用户授权带上的code将不一样，code只能使用一次，5分钟未被使用自动过期。
    // next： 无论access_token是否获取成功,一定要调用该方法
    // next说明：next方法接收两个参数
    // 参数1为通过code值请求后端获取到的access_token值，如果获取失败请填入空字符串''
    // 参数2(非必填，默认获取access_token切换到当前路由对象)，指定切换对象 next('/') 或者 next({ path: '/' })
    const cachedCode = localStorage.getItem('code')
    const cachedToken = localStorage.getItem('access_token')
    if (cachedCode === code && cachedToken) {
      next(cachedToken)
      return
    }

    requestH5Auth(code).then(response => {
      let value = response.data
      let accessToken = value.access_token
      if (accessToken) {
        let userinfo = value.data
        if (userinfo.userid) {
          persistH5Auth(code, value, accessToken)
          next(accessToken) // 获取access_toeken成功
        } else {
          this.$toast('抱歉，您没有权限访问该链接')
          next('', '/error')
        }
      } else {
        console.log('无授权')
        next('', '/error') // 获取access_token失败
      }
    }).catch(() => {
      console.log('无权限登录')
      next('', '/error') // ajax出现错误
    })
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
